import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Modal from "../../../shared/ui/Modal";
import { updateCustomer } from "../api";

const FIELDS = [
  { label: "First name", name: "firstName", required: true },
  { label: "Last name", name: "lastName", required: true },
  { label: "Display name", name: "displayName", required: true },
  { label: "Phone number", name: "phoneNumber", type: "tel" },
  { label: "Email", name: "email", type: "email", disabled: true },
  { label: "Username", name: "userName", disabled: true },
];

const EditProfileModal = ({ isOpen, onClose, customer, onSave }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    displayName: "",
    phoneNumber: "",
    email: "",
    userName: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (customer) {
      setFormData({
        firstName: customer.firstName || "",
        lastName: customer.lastName || "",
        displayName: customer.displayName || "",
        phoneNumber: customer.phoneNumber || "",
        email: customer.email || "",
        userName: customer.userName || "",
      });
    }
  }, [customer]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Email and username are shown read-only and sent back unchanged.
      await updateCustomer(formData);
      onSave?.({ ...customer, ...formData });
      onClose();
    } catch (error) {
      console.error("Error updating profile:", error.message);
      toast.error("Error updating profile. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Edit profile"
      subtitle="Update your name and contact number."
      dismissible={!loading}
      footer={
        <>
          <button type="button" className="ui-btn ui-btn--ghost" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button type="submit" form="edit-profile-form" className="ui-btn ui-btn--primary" disabled={loading}>
            {loading ? "Saving…" : "Save changes"}
          </button>
        </>
      }
    >
      <form id="edit-profile-form" className="ui-form" onSubmit={handleSubmit}>
        <div className="ui-row">
          {FIELDS.map((field) => (
            <div className="ui-field" key={field.name}>
              <label className="ui-label" htmlFor={`profile-${field.name}`}>
                {field.label}
                {!field.required && !field.disabled && <span className="ui-label__optional"> (optional)</span>}
              </label>
              <input
                id={`profile-${field.name}`}
                type={field.type || "text"}
                name={field.name}
                className="ui-input"
                value={formData[field.name]}
                onChange={handleChange}
                required={field.required}
                disabled={field.disabled}
              />
            </div>
          ))}
        </div>
        <p className="ui-hint">Email and username can't be changed.</p>
      </form>
    </Modal>
  );
};

export default EditProfileModal;
